import React, { useState } from 'react';
import { Icon } from '../icons';

// Schermata di cambio password. Usata come "gate" obbligatorio quando l'utente
// ha ancora la password di default (must_change_password), ma riutilizzabile.
function ChangePassword({ user, onDone, onLogout, forced = false }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (next !== confirm) { setError('La conferma non coincide con la nuova password'); return; }
    if (next.length < 8) { setError('La nuova password deve avere almeno 8 caratteri'); return; }
    setLoading(true);
    try {
      const res = await fetch('/api/auth/change-password', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ current_password: current, new_password: next }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Errore'); return; }
      onDone({ ...user, must_change_password: false });
    } catch {
      setError('Impossibile contattare il server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-hero">
        <div className="login-hero-top">
          <div className="login-logo"><Icon name="shield" size={22} strokeWidth={2} /></div>
          <div className="login-brand-text" style={{ color: '#fff' }}>
            <strong style={{ display: 'block' }}>HIPLAAS</strong>
            <span>Manager</span>
          </div>
        </div>
        <div className="login-hero-mid">
          <h2>Metti al sicuro il tuo account.</h2>
          <p>{forced
            ? 'Stai usando una password di default: per continuare devi impostarne una nuova.'
            : 'Aggiorna la password del tuo account.'}</p>
        </div>
        <div className="login-hero-list">
          <div><Icon name="shield" size={18} />Almeno 8 caratteri</div>
          <div><Icon name="key" size={18} />Diversa dallo username e da quella attuale</div>
        </div>
      </div>

      <div className="login-panel">
        <form className="login-card" onSubmit={submit}>
          <h1>Cambio password</h1>
          <p className="subtitle">Account: <strong>{user.username}</strong></p>

          {error && <div className="msg msg-error" style={{ marginBottom: '1rem' }}><Icon name="alert" size={16} />{error}</div>}

          <div className="field">
            <label htmlFor="cur">Password attuale</label>
            <input id="cur" className="input" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required autoFocus />
          </div>
          <div className="field">
            <label htmlFor="new">Nuova password</label>
            <input id="new" className="input" type="password" value={next} onChange={(e) => setNext(e.target.value)} required />
          </div>
          <div className="field">
            <label htmlFor="cnf">Conferma nuova password</label>
            <input id="cnf" className="input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
          </div>

          <button type="submit" className="btn btn-primary btn-block" disabled={loading} style={{ marginTop: '0.5rem' }}>
            {loading ? 'Aggiornamento…' : 'Aggiorna password'}
          </button>
          <button type="button" className="btn btn-ghost btn-block" onClick={onLogout} style={{ marginTop: '0.6rem' }}>
            Esci
          </button>
        </form>
      </div>
    </div>
  );
}

export default ChangePassword;
